export enum PaymentPageStatus {
  FAILED = 'failed',
  SUCCESSFUL = 'successful',
}
